module.exports = __webpack_public_path__ + "img/placket length.9877e96e.png";